import React, { useState, useEffect } from 'react';

function getPlayerStats() {
  const stats = localStorage.getItem('playerStats');
  if (!stats) return null;
  try {
    return JSON.parse(stats);
  } catch {
    return null;
  }
}

function formatDiffKey(key) {
  if (key === '0') return 'Par';
  if (key.startsWith('-')) return `${key} (Abaixo do par)`;
  if (key.startsWith('+')) return `${key} (Acima do par)`;
  return key;
}

const PlayerStatsAccordion = () => {
  const [open, setOpen] = useState(false);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    setStats(getPlayerStats());
  }, []);

  if (!stats) {
    return (
      <div className="player-stats-accordion">
        <button className="accordion-header" onClick={() => setOpen(o => !o)}>
          Estatísticas do Jogador
        </button>
        {open && (
          <div className="accordion-content">
            <p>Nenhuma estatística registrada ainda.</p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="player-stats-accordion">
      <button className="accordion-header" onClick={() => setOpen(o => !o)}>
        Estatísticas do Jogador {open ? '▲' : '▼'}
      </button>
      {open && (
        <div className="accordion-content">
          <div><b>Vitórias seguidas:</b> {stats.streak || 0}</div>
          <div><b>Total de vitórias:</b> {stats.totalWins || 0}</div>
          <div style={{ margin: '0.5rem 0' }}><b>Distribuição por diferença do par:</b></div>
          <ul style={{ marginLeft: '1.2rem' }}>
            {stats.statsByDiff && Object.keys(stats.statsByDiff).sort((a, b) => parseInt(a) - parseInt(b)).map(key => (
              <li key={key}>{formatDiffKey(key)}: <b>{stats.statsByDiff[key]}</b></li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PlayerStatsAccordion;
